import { Component, Input, OnInit } from '@angular/core';
import { ForumService } from '../../forum.service';
import { UserService } from '../../../../core/services/core.user.service'; 
import { gfDateFunction, gfToDateFunction } from '../../../../core/pipes/date/date.functions';
import { decodeHtmlEntities } from '../../../../core/pipes/text/text.functions';
import { isMarkdownBody } from '../../../../core/services/message-body-format';
import * as moment from 'moment';
import * as _ from 'lodash';

@Component({
  selector: 'gf-messages',
  template: require('./messages.component.html')
})
export class MessagesComponent implements OnInit {
  @Input() messages: any[];
  @Input() deletemessage: any;
  @Input() updatemessage: any;
  @Input() parent: any;
  @Input() permlevel: any;
  @Input() useeditor: any;
  
  unixName: string;
  sending: boolean;

  constructor(private forumService: ForumService, private userService: UserService) {
  }

  ngOnInit(): void {
    this.unixName = this.userService.session.getUnixName();
    this.useeditor = typeof this.useeditor !== 'boolean' ? true : this.useeditor;
  }

  isCurrentUser(username: string) {
    return username === this.unixName;
  }

  /**
   * Whether a body is raw Markdown, and so belongs to gf-markdown-viewer.
   *
   * This screen and the live chat widget render the same rows -- a chat thread
   * is a forum thread -- so both have to route a message the same way, or the
   * same message looks different depending on which screen it is opened from.
   */
  isMarkdownMessage(message: any): boolean {
    return isMarkdownBody(message);
  }

  delimiterText(idx: number, list: any[]) {
    let previousDate = new Date();

    for (let lastIdx = idx - 1; lastIdx > -1; lastIdx--) {
      const previousItem = list[lastIdx];
      previousDate = gfToDateFunction(previousItem.postDate);
      if (previousDate !== null) {
        break;
      }
    }

    const item = list[idx];
    const date = gfToDateFunction(item.postDate);
    if (date === null) {
      return false;
    }

    if (
      previousDate === null ||
      idx === 0 ||
      date.toDateString() !== previousDate.toDateString()
    ) {
      return gfDateFunction(date, 'll');
    }

    return false;
  }

  showChildren(message: any) {
    message.loading = true;
    message.page = _.get(message, 'page', Math.ceil(message.rel.childcount / 10) + 1) - 1;
    message.childMessages = _.map(_.get(message, 'childMessages', []), (item) => {
      item.body = _.unescape(decodeHtmlEntities(item.body));
      return item;
    });

    this.forumService
      .threadMessages(message.forumThread,  message.id, {pageNum: message.page, pageSize: 10})
      .then((response: any) => {
        _.each(response.items, (item) => {
          if (_.find(message.childMessages, (i) => i.id === item.id)) {
            return;
          } else {
            message.childMessages.push(item);
          }
        });

        message.childMessages = _.sortBy(message.childMessages, (item) => item.id);
        message.childMessages = _.map(_.get(message, 'childMessages', []), (item) => {
          item.body = _.unescape(decodeHtmlEntities(item.body));
          return item;
        });
      })
      .then(() => {
        message.loading = false;
      });
  }

  postReply(message: any) {
    this.sending = true;
    message.loading = true;

    this.updatemessage(0, message.replyText, message.forumThread, message.id)
      .then((response) => {
          message.reply = false;
          message.rel.childCount++;
          message.childMessages = message.childMessages || [];
          message.childMessages = message.childMessages.concat([
            {
              body: message.replyText,
              forumThread: message.forumThread,
              user: this.userService.session.getUser(),
              parentForumMessageId: message.id,
              postDate: moment().format('YYYY-MM-DDTHH:mm:ss ZZ'),
              id: parseInt(response.location.match('\\d+')[0])
            }
          ]);
        },
        (response) => {
          console.log(response);
        }
      )
      .then(() => {
        this.sending = false;
        message.loading = false;
      });
  }

  setReplyText(body: any, message: any) {
    message.replyText = body;
  }

  cancelEdit(message: any) {
    message.editing = false;
    message.body = message.originalBody;
  }

  startEdit(message: any) {
    message.editing = true;
    message.originalBody = message.body;
  }

  saveEdit(message: any) {
    this.sending = true;
    message.loading = true;

    // Thread parameter can be either object or ID
    const threadId = typeof message.forumThread === 'object' ? message.forumThread.id : message.forumThread;

    this.updatemessage(message.id, message.body, threadId)
      .then(() => {
        message.editing = false;
        delete message.originalBody;
      })
      .finally(() => {
        this.sending = false;
        message.loading = false;
      });
  }

  trackById(index: number, item: any): any {
    return item?.id ?? item;
  }
}
